import module from 'colaborador/module.js'

const schema = {
  descuentoId: 'number',
  prestamoId: 'number',
  importe: 'number',
  abonado: 'number',
  concepto: '',
  descripcion: '',
  fechaInicial: 'date',
  fecha: 'date',
  concluido: 'boolean',
  desglose: {
    desgloseId: 'number',
    desgloseFechaInicial: 'date',
    desgloseFechaFinal: 'date',
    concluido: 'boolean'
  }
}

export class ColaboradorPrestamoExternoService {
  constructor ($http) {
    this.$http = $http
  }

  get (descuentoId) {
    return this.$http.get('/api/colaborador/prestamo-externo', {
      params: {descuentoId},
      schema,
    })
  }

  put (data){
    return this.$http.put('/api/colaborador/prestamo-externo', data, {
      schema,
    })
  }

  delete (descuentoId) {
    return this.$http.delete('/api/colaborador/prestamo-externo', {
      params: {descuentoId},
    })
  }
}

module.service('ColaboradorPrestamoExterno', ColaboradorPrestamoExternoService)


// WEBPACK FOOTER //
// ./src/colaborador/services/Colaborador/PrestamoExterno.js